import { useHeaderContext } from '@/creditflowresearch/application/Header/HeaderContext';
import SearchResults from './SearchResults';

interface IProps {
  variant?: 'default' | 'creditflow',
}

const SearchResultsContainer = ({ variant }: IProps) => {
  const {
    searchText,
    searchResult,
    isSearchFetching,
    resetSearchResult,
  } = useHeaderContext();

  return (
    <SearchResults
      searchText={ searchText }
      searchResult={ searchResult }
      isSearchFetching={ isSearchFetching }
      onSearchResultItemClick={ resetSearchResult }
      variant={ variant }
    />
  );
};

export default SearchResultsContainer;
